import React from "react";
import { useParams } from "react-router-dom";

export function withParamsHooks(Component: any) {
  return (props: any) => (<Component params={useParams()} {...props}/>);
}
